<template>
 <div v-if="appearances.sponsor_logo_desktop" class="desktop-banner">
    <div class="__image">
      <img :src="`${appearances.sponsor_logo_desktop}`" />
    </div>
    <div class="__button">
      <a 
        :style="{ '--apperances-color': appearances.schema_color || 'var(--primary)' }"
        v-if="computedUrl"
        :href="computedUrl"
        class="dynamic-color-schema nominate__click btn-primary btn btn-sm btn-block"
        target="_blank"
      >
        More details
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppearancesDraftsDesktopBanner',
  props: {
    appearances: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedUrl() {
      let url = this.appearances.sponsor_link || ''
      if (url && !/^https?:\/\//i.test(url)) {
        url = `https://${url}`
      }
      return url || null
    }
  }
}
</script>
<style scoped>
  .__image img {
    width: 100%;
    height: auto;
  }

  .__button > .btn-primary {
    border: 2px solid var(--apperances-color);
    color: white;
    background-color: var(--apperances-color);
    padding: 0.25rem 1.5rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    font-weight: 400;
    font-size: 16px;
  }

  .__button > .btn-primary:hover,
  .__button > .btn-primary:focus,
  .__button > .btn-primary:active,
  .__button > .btn-primary:active:focus {
    background-color: var(--apperances-color) !important;
    border-color: var(--apperances-color) !important;
    box-shadow: none;
    opacity: 0.85;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/AppearancesDraftsDesktopBanner.vue